<template>
  <!-- 预配舱单管理 -->
  <div class="page-container-manage page-container-booking" id="ebOrderContainer">
    <el-form ref="searchFromRef" class="form-panel" label-position="top">
      <el-row class="content-panel manage-content-panel">
        <!-- 查询-start -->
        <el-row style="background-color:#fff; padding:10px 10px 0 10px; border-radius: 10px;">
          <el-row :gutter="10">
          <el-col :span="10">
            <el-form-item>
              <el-input
                  size="small"
                  placeholder="请输入单个或多个客户业务编号、订单号、提单号进行查询，多个单号用分号隔开"
                  clearable
                  v-model="formData.deployPort"
                  :title="formData.deployPort"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="margin-top: 2px">
            <el-row>
              <el-button
                class="el-button-search"
                type="primary"
                size="small"
                plain
                @click="queryForm"
              >查询
              </el-button
              >
              <el-button type="primary" size="small" plain @click="resetForm"
              >重置
              </el-button
              >
              <el-button
              class="advanced-query-btn"
                type="primary"
                size="small"
                plain
                @click="changMoreInfoVisible"
                v-if="!moreInfoVisible ? 'hidden' : ''"
              >显示高级查询
              <svg-icon icon-class="arrow-down" class="svg-change-color"></svg-icon>
              </el-button>
              <el-button
              class="advanced-query-btn"
                type="primary"
                size="small"
                plain
                @click="changMoreInfoVisible"
                v-if="moreInfoVisible ? 'hidden' : ''"
              >隐藏高级查询
              <svg-icon icon-class="arrow-up" class="svg-change-color"></svg-icon>
              </el-button>
            </el-row>
          </el-col>
        </el-row>
        <!-- 查询-end -->
        <!-- 高级查询-start -->
        <el-row
            class="content-panel title-fix advanced-query"
            v-show="moreInfoVisible"
        >
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="船公司:">
                <el-associate
                    style="width: 100%"
                    :columns="associate_columns_carrier"
                    :query-method="associate_queryMethod_carrier"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="custAlias"
                    value-prop="custAlias"
                    placeholder=""
                    v-model="searchData.carrierName"
                    :title="searchData.carrierName"
                    @change="giveCsCustId"
                    size="mini"
                    case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="16">
                  <el-form-item label="船名/航次:">
                    <el-associate
                      ref="vesselAssociate"
                      style="width: 100%"
                      :columns="associate_columns_vessel"
                      :query-method="associate_queryMethod_vessel"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="vesselName"
                      value-prop="vesselId"
                      placeholder=""
                      v-model="searchData.realVesselNameEn"
                      :title="searchData.realVesselNameEn"
                      size="mini"
                      name="vesselName"
                      @change="onChangeVessel"
                      case="upper"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <label slot="label" class="label_no"></label>
                    <el-input
                      size="mini"
                      placeholder=""
                      clearable
                      v-model="searchData.realVoyage"
                      :title="searchData.realVoyage"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="创建日期从:">
                    <el-date-picker
                        v-model="searchData.startTime"
                        :title="searchData.startTime"
                        align="right"
                        type="date"
                        style="width: 100%"
                        size="mini"
                        placeholder=""
                        :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="创建日期到:">
                    <el-date-picker
                        v-model="searchData.endTime"
                        :title="searchData.endTime"
                        align="right"
                        type="date"
                        style="width: 100%"
                        size="mini"
                        placeholder=""
                        :picker-options="pickerOptions"
                        @change="changeEndTime"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="大船开航日期从:">
                    <el-date-picker
                        v-model="searchData.startEtd"
                        :title="searchData.startEtd"
                        align="right"
                        type="date"
                        style="width: 100%"
                        size="mini"
                        placeholder=""
                        :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="大船开航日期到:">
                    <el-date-picker
                        v-model="searchData.endEtd"
                        :title="searchData.endEtd"
                        align="right"
                        type="date"
                        style="width: 100%"
                        size="mini"
                        placeholder=""
                        :picker-options="pickerOptions"
                        @change="changeEndEtd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="装货港:">
                <el-associate
                    style="width: 100%"
                    :columns="associate_columns_po"
                    :query-method="associate_queryMethod_po"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="portNameEn"
                    value-prop="mdPortId"
                    placeholder=""
                    v-model="searchData.polId"
                    :title="searchData.polId"
                    @change="onPolChange"
                    size="mini"
                    name="polName"
                    case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="卸货港:">
                <el-associate
                    style="width: 100%"
                    :columns="associate_columns_po"
                    :query-method="associate_queryMethod_po"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="portNameEn"
                    value-prop="mdPortId"
                    placeholder=""
                    v-model="searchData.podId"
                    :title="searchData.podId"
                    @change="onPodChange"
                    size="mini"
                    name="podName"
                    case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="16">
                  <el-form-item label="报关船名/航次:">
                    <el-associate
                      ref="customsVesselAssociate"
                      style="width: 100%"
                      :columns="associate_columns_vessel"
                      :query-method="associate_queryMethod_vessel"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="vesselName"
                      value-prop="vesselId"
                      placeholder=""
                      v-model="searchData.customsVesselName"
                      :title="searchData.customsVesselName"
                      size="mini"
                      name="vesselName"
                      @change="onChangeCustomsVessel"
                      case="upper"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <label slot="label" class="label_no"></label>
                    <el-input
                      size="mini"
                      placeholder=""
                      clearable
                      v-model="searchData.customsVoyage"
                      :title="searchData.customsVoyage"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6" style="padding-top: 17px">
              <el-row
                  type="flex"
                  justify="end"
                  align="middle"
                  :gutter="10"
                  class="el-row-margin"
              >
                <el-button
                    class="el-button-search"
                    type="primary"
                    size="small"
                    plain
                    @click="queryMoreForm"
                >查询
                </el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    plain
                    @click="resetMoreForm"
                >重置
                </el-button
                >
              </el-row>
            </el-col>
          </el-row>
        </el-row>
     </el-row>
        <!-- 高级查询-end -->
        <!-- 状态栏-start -->
        <el-row>
           <el-col class="tabsContainer tab-module">
            <el-tabs
                type="border-card"
                v-model="activeName"
                @tab-click="handleClick"
            >
              <el-tab-pane
                  :label="'全部(' + count0 + ')'"
                  name="all"
              ></el-tab-pane>
              <el-tab-pane
                v-for="(item, index) in ebftPlanApprovalStatusList"
                :key="index"
                :name="item.value"
              >
              <span slot="label">{{item.name + '('}}<span :class="[item.count > 0? 'hasTabPane': '']">{{item.count}}</span><span>{{')'}}</span></span>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
        <el-row class="state-panel">
        <!-- 状态栏-end -->
        <!-- 按钮栏-start -->
        <el-row style="background-color:#fff;padding:10px">
          <el-button type="primary" size="small" plain @click="updateManifest"
          >编辑舱单
          </el-button
          >
          <el-button type="primary" size="small" plain @click="replaceManifest"
          >代发舱单
          </el-button
          >
          <el-button type="primary" size="small" plain @click="makeManifest"
          >制作舱单
          </el-button
          >
          <el-button type="primary" size="small" plain @click="commitManifest"
          >提交舱单
          </el-button
          >
          <el-button type="primary" size="small" plain @click="deleteDraft"
          >删除草稿
          </el-button
          >
          <el-button type="primary" size="small" plain @click="statusHistory"
          >状态历史
          </el-button
          >
          <el-button type="primary" size="small" plain @click="cancelSub"
          >撤销提交
          </el-button
          >
        </el-row>
        <!-- 按钮栏-end -->
        <!-- 表格-start -->
        <el-row style="padding: 0 1px">
          <hot-table
              ref="ebFtPlanTableRef"
              :data-source="ebFtPlanTableDataSource"
              :settings="tableSettings"
              col-settings-key="ebFtPlan"
              @cellDblclick="clickBill"
              @dblclick="dbClickBill">
            <hot-column :has-tip="true" data="orderNo" title="订单号" width="150"></hot-column>
            <hot-column :has-tip="true" data="mblNo" title="提单号" width="150"></hot-column>
            <hot-column
                :has-tip="true"
                data="manifestStatus"
                title="舱单状态"
                width="150"
                dictName="EB_FT_PLAN_STATUS"
            >
            </hot-column>

            <hot-column
                :has-tip="true"
                data="approvalStatus"
                title="提交状态"
                width="150"
                dictName="EB_FT_SUB_STATUS"
            >
            </hot-column>

            <hot-column
                :has-tip="true"
                data="carrierName"
                title="船公司"
                width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              data="realVesselNameEn"
              title="船名"
              width="150"
            >
            </hot-column>
            <hot-column :has-tip="true" data="realVoyage" title="航次" width="150">
            </hot-column>
            <hot-column
                :has-tip="true"
                data="customsVesselName"
                title="报关船名"
                width="150"
            >
            </hot-column>

            <hot-column :has-tip="true" data="customsVoyage" title="报关航次" width="150">
            </hot-column>

            <hot-column
                :has-tip="true"
                data="shipAgencyName"
                title="船代公司"
                width="150"
            >
            </hot-column>

            <hot-column
                :has-tip="true"
                data="creatorName"
                title="创建人"
                width="150"
            >
            </hot-column>

            <hot-column
                :has-tip="true"
                data="createTime"
                date-format="YYYY-MM-DD HH:mm:ss"
                title="创建时间"
                width="150"
            >
            </hot-column>
          </hot-table>

          <!-- 分页start -->
          <div class="pg_div">
            <el-pagination
                :current-page="pageConfig.currentPage"
                :layout="pageConfig.layout"
                :page-size="pageConfig.pageSize"
                :page-sizes="pageConfig.pageSizes"
                :total="pageConfig.total"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
            />
          </div>
          <!-- 分页end -->
        </el-row>
        <!-- 表格-end -->
      </el-row>
      </el-row>
    </el-form>
    <!-- 舱单制作弹窗 -->
    <MakeManifest :addVisibleFlagInit.sync="isShowMakeManifest"></MakeManifest>
  </div>
</template>

<script>
import ResizeObserver from "resize-observer-polyfill";

import { queryCarrierInfo, queryDictRows, queryPoInfo, queryVoyageInfo, } from "@/api/commonService";
import columnDoRenderer from "@/components/CustomRenderer/columnDoRenderer";
import {
  batchSubmitEbFtPlan,
  getManifestManage,
  queryAllEbftPlan,
  queryMoreEbFtPlan,
  updateEbFtPlanIsDeletedStatus,
} from "@/api/manifest";
import { batchRevokeSub } from "@/api/bookingRequest";
import MakeManifest from "@/views/manifest/MakeManifest";

export default {
  name: "manifestManagement",
  components: {
    column_do_renderer: columnDoRenderer,
    MakeManifest,
  },
  data() {
    return {
      ebftPlanApprovalStatusAllList: [],
      resizeObserver: null,
      //查询条件
      no: "",
      //查询
      searchData: {
        customsVesselName: "",
        customsVoyage: "",
        realVoyage: "",
        csCustId: "",
        podId: "",
        polId: "",
        vesselId: "",
        carrierName: "",
        realVesselNameEn: "",
        voyage: "",
        ebFtStartTime: "",
        ebFtEndTime: "",
        polName: "",
        podName: "",
        startEtd: new Date(new Date(new Date(new Date().getTime() - 24 * 1000 * 3600 * 60).toLocaleDateString()).getTime()),
        endEtd: new Date(new Date(new Date(new Date().getTime() + 24 * 1000 * 3600 * 31).toLocaleDateString()).getTime() + 24 * 1000 * 3600 - 1)
      },
      //搜索框
      formData: {
        deployPort: "",
      },
      //标志点击哪个查询按钮
      queryButton: 0,
      //显示高级查询
      moreInfoVisible: false,
      //tab状态栏
      activeName: "all",
      //各订单状态数量
      count0: 0,
      //新增弹出框状态
      addVisible: false,
      //制作舱单弹窗状态
      isShowMakeManifest: false,
      //勾选数据
      selectedData: {},
      //传递给复制/新增
      addOrCopyData: {},
      //状态列表
      ebftPlanApprovalStatusList: [],
      // 表格数据
      ebFtPlanTableDataSource: [],
      //当前行数据
      currentEbOrder: {},
      // 表格设置
      tableSettings: {
        height: 520,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      pageID: {},
      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 100,
        pagerCount: 100,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100, 500],
      },
      // 船公司联想控件
      associate_columns_carrier: [
        {
          title: "中文简称",
          field: "custAlias",
        },
        {
          title: "中文全称",
          field: "custNameCn",
        },
        {
          title: "助记码",
          field: "mnemonicCode",
        },
      ],
      // 船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      // 航次联想控件
      associate_columns_voyage: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
        {
          title: "航次代码",
          field: "voyageCode",
        },
      ],
      // 装/卸货港联想控件
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      //日期设置
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  async created() {
  },
  activated() {
    setTimeout(() => {
      this.$nextTick (() => {
        this.$refs.ebFtPlanTableRef.render()
      })
    },100);
  },
  mounted() {
    let self = this;
    self.queryApprovalStatus();
    self.queryEbFtStatus();
    if (self.$route.params.fromWhere === "afterSubmit"){
      self.queryMoreForm();
    }
    // 监听外层容器div宽度的变化，做表格自适应
    this.tableSettings.height = document.body.clientHeight - 100 -150;
  },
  methods: {
    giveCsCustId(value,selectedRows){
      let self = this;
      self.searchData.csCustId = selectedRows.csCustId;
    },
    changMoreInfoVisible() {
      this.moreInfoVisible = !this.moreInfoVisible
      if (this.moreInfoVisible) {
        this.tableSettings.height = this.tableSettings.height - 143
      }
      if(!this.moreInfoVisible) {
        this.tableSettings.height = this.tableSettings.height +143
      }
    },
    changeEndEtd() {
      let self = this;
      self.searchData.endEtd = new Date(self.searchData.endEtd.getTime() + 1000 * 24 * 3600 - 100)
    },
    changeEndTime() {
      let self = this;
      self.searchData.endTime = new Date(self.searchData.endTime.getTime() + 1000 * 24 * 3600 - 100)
    },
    onPolChange(value,selectedRows){
      this.searchData.polId = selectedRows.mdPortId;
      this.searchData.polName = selectedRows.portNameEn;
    },
    onPodChange(value,selectedRows){
      this.searchData.podId = selectedRows.mdPortId;
      this.searchData.podName = selectedRows.portNameEn;
    },
    onChangeCustomsVessel() {
      let record = this.$refs.customsVesselAssociate.list[this.$refs.customsVesselAssociate.hoverIndex];
      this.searchData.customsVesselId = "";
      this.searchData.customsVesselName = record.vesselName;
      this.searchData.customsVesselId = record.vesselId;
      this.searchData.customsVoyage = record.voyage;
    },
    onChangeVessel() {
      let record = this.$refs.vesselAssociate.list[this.$refs.vesselAssociate.hoverIndex];
      this.searchData.realVesselId = "";
      this.searchData.realVesselNameEn = record.vesselName;
      this.searchData.realVesselId = record.vesselId;
      this.searchData.realVoyage = record.voyage;
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SO%",
          isDeleted6: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    associate_queryMethod_vessel({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.vesselName"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
            "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
            "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 装/卸货港联想控件数据源
    associate_queryMethod_po({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
            "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.queryStatusPage();
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageConfig.currentPage = val;
      let self = this;
      self.queryStatusPage();
    },
    // 单击行事件
    rowClick(val) {
      let self = this;
      self.currentEbOrder = val.record;
    },
    // tab切换事件
    handleClick(tab, event) {
      let self = this;
      if (tab.name === "all") {
        self.ebFtPlanTableDataSource = self.ebftPlanApprovalStatusAllList;
        return;
      }
      self.pageConfig.currentPage = 1;
      let target = self.ebftPlanApprovalStatusList.find(
          (item) => item.value === tab.paneName
      );
      self.ebFtPlanTableDataSource = target.filterList;
    },
    queryStatusPage() {
      let self = this;
      if (self.queryButton === 1) {
        self.queryForm();
      } else if (self.queryButton === 2) {
        self.queryMoreForm();
      }
    },
    // 表格双击事件
    dbClickBill(val) {
      let self = this;
      let row = val.record;
      if (val.col !== 1) {
        self.$router.push({
          name: "manifestEdi",
          query: {
            ebOrderId: row.ebOrderId,
            isAddManiFest: false,
            mainfest: 'updateManifest'
          },
        });
      }
    },
    //表格单击事件
    clickBill(val) {
      let self = this;
      let row = val.record;
      self.$router.push({
        name: "manifestEdi",
        query: {
          ebOrderId: row.ebOrderId,
          isAddManiFest: false,
          mainfest: 'updateManifest'
        },
      });
    },
    //重置搜索框
    resetForm() {
      this.formData = {};
    },
    resetMoreForm() {
      this.searchData = {
        carrierName: "",
        realVesselNameEn: "",
        voyage: "",
        ebFtStartTime: "",
        ebFtEndTime: "",
        polName: "",
        podName: "",
        startEtd: new Date(new Date(new Date(new Date().getTime() - 24 * 1000 * 3600 * 60).toLocaleDateString()).getTime()),
        endEtd: new Date(new Date(new Date(new Date().getTime() + 24 * 1000 * 3600 * 31).toLocaleDateString()).getTime() + 24 * 1000 * 3600 - 1)
      };
    },
    //简单查询
    queryForm() {
      let self = this;
      self.queryButton = 1;
      if (self.formData.deployPort.trim().length === 0) {
        self.queryMoreForm();
        // self.$coreMethods.message('warning', '请输入单个或多个委托号、提单号')
      } else {
        let queryData = {
          currentPage: self.pageConfig.currentPage,
          pageSize: self.pageConfig.pageSize,
          // orderStatus: self.activeName === "all" ? "" : self.activeName,
        };
        // self.queryAll();
        if (self.formData.deployPort.split(";").length > 1) {
          queryData.arrayNoList = self.formData.deployPort.split(";");
        } else {
          queryData.arrayNo = "%" + self.formData.deployPort + "%";
        }
        getManifestManage(queryData).then((res) => {
          if (res.success) {
            self.ebFtPlanTableDataSource = res.records.records;
            self.pageConfig.total = res.records.totalRecord;
            self.filterStatus(res.records.records)
            if (res.records.totalRecord === 0){
              self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            }else {
              self.$coreMethods.message("success", "查询成功！");
            }
          }
        });
      }
    },
    //高级查询
    queryMoreForm() {
      let self = this;
      self.searchData.orderStatus = self.activeName === "all" ? "" : self.activeName;
      self.queryButton = 2;
      let num = 0
      for (let s in self.searchData) {
        if (self.searchData[s] !== "") {
          num++
        }
      }
      if (num === 0) {
        self.$coreMethods.message('warning', '至少输入一个查询条件')
      } else {
        self.searchData.currentPage = self.pageConfig.currentPage;
        self.searchData.pageSize = self.pageConfig.pageSize;
        self.searchData.orderStatus = self.activeName === "all" ? "" : self.activeName;
        let oldEndTime = "";
        if (self.searchData.endTime !== undefined){
          oldEndTime = self.searchData.endTime;
          self.searchData.endTime = new Date(self.searchData.endTime.getTime() + 1000 * 24 * 3600 - 100);
        }
        getManifestManage(self.searchData).then((res) => {
          //self.searchData.voyage = voyage;
          if (oldEndTime !== ""){
            self.searchData.endTime = oldEndTime;
          }
          if (res.success) {
            self.ebFtPlanTableDataSource = res.records.records;
            self.pageConfig.total = res.records.totalRecord;
            self.filterStatus(res.records.records)
            if (res.records.totalRecord === 0){
              self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            }else {
              self.$coreMethods.message("success", "查询成功！");
            }
          }
        });
      }
    },
    //简单查询所有
    queryAll(c) {
      let self = this;
      queryAllEbftPlan(c).then((res) => {
        if (res.data != null) {
          self.pageConfig.total = res.data.length;
          self.filterStatus(res.data);
        }
      });
    },
    //高级查询所有
    queryAllMore() {
      let self = this;
      let searchData = {
        carrierName: self.searchData.carrierName,
        vesselNameEn: self.searchData.vesselNameEn,
        voyage: self.searchData.voyage,
        startTime: self.searchData.startTime,
        endTime: self.searchData.endTime,
        polName: self.searchData.polName,
        podName: self.searchData.podName,
        orderStatus: "",
      };
      queryMoreEbFtPlan(searchData).then((res) => {
        if (res.data != null) {
          self.filterStatus(res.data);
        }
      });
    },
    //各舱单提交状态数量
    filterStatus(data) {
      let self = this;
      self.ebftPlanApprovalStatusAllList = JSON.parse(JSON.stringify(data));
      self.initStatus();
      self.count0 = data.length
      self.ebftPlanApprovalStatusList.forEach((dictItem) => {
        let filterList = data.filter(
            (item) => dictItem.value === item.approvalStatus
        );
        dictItem.filterList = filterList;
        dictItem.count = filterList.length;
      });

      if (self.activeName !== 'all') {
        let targetStatus = self.ebftPlanApprovalStatusList.find(item => item.value === self.activeName)
        self.ebFtPlanTableDataSource = targetStatus.filterList
      }
    },
    initStatus() {
      let self = this;
      self.ebftPlanApprovalStatusList.forEach((dictItem) => {
        dictItem.count = 0;
      });
    },
    //获取订单提交状态数据字典
    queryApprovalStatus() {
      let self = this;
      queryDictRows("MD_CODE_DICT$EB_FT_SUB_STATUS,MD_CODE_DICT$EB_FT_PLAN_STATUS").then((res) => {
        let dict = [];
        res['MD_CODE_DICT$EB_FT_SUB_STATUS'].forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = []
          dict.push(param);
        });
        self.ebftPlanApprovalStatusList = dict;
        console.log("ebftPlanApprovalStatusList", dict);
        // 数据字典
        self.$hotTableUtils.registDict({
          EB_FT_SUB_STATUS: dict,
        });

        let dict2 = [];
        res.MD_CODE_DICT$EB_FT_PLAN_STATUS.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = []
          dict2.push(param);
        });
        // 数据字典
        self.$hotTableUtils.registDict({
          EB_FT_PLAN_STATUS: dict2,
        });
      });
    },
    //获取舱单状态数据字典
    queryEbFtStatus() {
      let self = this;
      queryDictRows("MD_CODE_DICT$EB_FT_SUB_STATUS").then((res) => {
        let dict = [];
        res.MD_CODE_DICT$EB_FT_STATUS.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          dict.push(param);
        });
        // 数据字典
        self.$hotTableUtils.registDict({
          EB_FT_STATUS: dict,
        });
      });
    },

    //点击
    clickModule(e) {
    },
    //编辑
    updateManifest() {
      let self = this;
      //获取勾选行数据
      let params = self.$refs.ebFtPlanTableRef.getSelections();
      if (params.length !== 1) return self.$coreMethods.message("warning", "请勾选一条记录");
      window.localStorage.setItem("mainfest", "updateManifest");
      self.$router.push({
        name: "manifestEdi",
        query: {
          ebOrderId: params[0].ebOrderId,
          isAddManiFest: false,
          mainfest: 'updateManifest'
        },
      });
    },
    //代发舱单
    replaceManifest() {
      this.$router.push({
        name: "manifestAdd",
        params: {
          manifestStatus: "UNSENT",
          approvalStatus: "NEW",
        },
        query: {
          mainfest: 'replaceManifest'
        }
      });
    },

    //制作舱单
    makeManifest() {
      this.isShowMakeManifest = true;
    },
    closeMakeManifest() {
      console.log(1111);
      this.isShowMakeManifest = false;
    },
    //提交舱单
    commitManifest() {
      let self = this;
      let flag = true;
      let params = self.$refs.ebFtPlanTableRef.getSelections();
      if (params.length === 0) {
        self.$coreMethods.message("warning", "请勾选记录");
      } else {
        params.forEach((item) => {
          //判断选中的订单状态为草稿
          if (item.approvalStatus !== "NEW") {
            flag = false;
          }
        });
        if (!flag) {
          self.$coreMethods.message("warning", "请选择状态为草稿的记录");
        } else {
          batchSubmitEbFtPlan(params).then((res) => {
            if (res.success) {
              self.$coreMethods.message("success", "批量提交成功");
              self.queryStatusPage();
            } else {
              self.$coreMethods.message("error", "批量提交失败");
            }
          });
        }
      }
    },
    //删除草稿
    deleteDraft() {
      let self = this;
      //获取勾选行数据
      let params = self.$refs.ebFtPlanTableRef.getSelections();
      let searchData = [];
      if (params.length === 0) {
        self.$coreMethods.message("warning", "请至少选择一条记录进行删除！");
      } else {
        //遍历选中的数据，判断提交状态是否为草稿
        params.forEach((item) => {
          if (item.approvalStatus !== "NEW") {
            self.$coreMethods.message("warning", "请选择提交状态为草稿的数据！");
            // return;
          } else {
            searchData.push(item.ebFtPlanId);
          }
        });
        if (searchData.length !== 0){
          //删除表格选中数据并设置is_deleted=1
          updateEbFtPlanIsDeletedStatus(searchData).then((res) => {
            if (res.success) {
              let index = self.ebFtPlanTableDataSource.indexOf(params);
              self.ebFtPlanTableDataSource.splice(index, params.length);
              if (self.queryButton === 1) {
                self.queryForm();
              } else if (self.queryButton === 2) {
                self.queryMoreForm();
              }
            }
          });
        }
      }
    },
    //状态历史
    statusHistory() {
      let self = this;
      let params = self.$refs.ebFtPlanTableRef.getSelections();
      if (params.length === 0 || params.length > 1) {
        self.$coreMethods.message("warning", "请勾选一条记录");
      } else {
        this.$router.push({
          name: "StatusHistory",
          params: {
            orderNo: params[0].orderNo,
          },
        });
      }
    },
    cancelSub() {
      let self = this;
      //获取勾选行数据
      let params = self.$refs.ebFtPlanTableRef.getSelections();
      let ebOrderIdsArr = [];
      let approvalStatusArr = [];
      let approvalStatus = "";
      if (params.length === 0) {
        self.$coreMethods.message("warning", "请勾选记录");
      } else {
        params.forEach((item) => {
          approvalStatusArr.push(item.approvalStatus);
          ebOrderIdsArr.push(item.ebOrderId);
        });
        let statusSet = new Set(approvalStatusArr);
        if (statusSet.has("NEW") || statusSet.has("CRM") || statusSet.has("REF")) {
          self.$coreMethods.message("warning", "请确认舱单提交状态为是否为提交");
        } else {
          approvalStatus = "NEW";
          self.$coreMethods.confirm(
            function () {
              batchRevokeSub({
                ebOrderIds: ebOrderIdsArr,
                approvalStatus: approvalStatus,
              }).then((res) => {
                if (res.success) {
                  params.forEach((item) => {
                    item.approvalStatus = approvalStatus;
                  });
                  self.$coreMethods.message("success", "撤销提交成功");
                  self.submitVisible = true;
                } else {
                  self.$coreMethods.message("error", "撤销提交失败");
                }
              });
            },
            function () {
            },
            false,
            "是否执行撤销操作？"
          );
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-tabs__content {
  display: none;
}
</style>
